export const initialValues = {
  "name": "",
  "username": "",
  "email": "",
  "password": "",
  "confirmPass": "",
  "stationsSelected": [],
  "stationsIds": [],
  "rulesSelected": [],
  "printers": []
}
export const initialValuesPass = {
  "password": "",
  "confirmPass": "",
}

export const fieldValidations = {
  "name": {
    "required": true
  },
  "username": {
    "required": true
  },
  "email": {
    "required": true
  },
  "password": {
    "required": true
  },
  "confirmPass": {
    "required": true
  }
}
export const fieldValidationsPass = {
  "password": {
    "required": true
  },
  "confirmPass": {
    "required": true
  }
}
